<div class="page-container" [class.loading]="isLoading">
    <div class="flex align-items-center justify-end">
        <app-filter-date
            class="margin-right-2"
            style="padding: 0"
            *ngIf="report && report.isDateBased"
            [startAt]="initialStartAt"
            [endAt]="initialEndAt"
            (filter)="onDateFilter($event)"
        ></app-filter-date>
        <app-deprecated-filter
            class="margin-right-2"
            [capitalize]="true"
            [filters]="filters"
            [filterValues]="filterValues"
            (filter)="onFilter($event)"
        ></app-deprecated-filter>

        <ui-button
            *ngIf="!hasDetailAdditionsAndTerminationsReport || !this.shouldLoadDetailReport"
            (click)="onExport()"
            type="primary"
            style="float: right"
            >{{ 'reporting.reports.export' | translate }}
        </ui-button>
    </div>

    <!-- class="ui right floated" -->
    <app-header [title]="name" [back]="true"></app-header>

    <p>{{ description | translate }}</p>

    <ui-card *ngIf="!hasDetailAdditionsAndTerminationsReport || !this.shouldLoadDetailReport">
        <app-chart *ngIf="chartData?.datasets" [chartData]="chartData" [report]="report"></app-chart>
    </ui-card>

    <ui-card *ngIf="hasDetailAdditionsAndTerminationsReport && this.shouldLoadDetailReport">
        <div class="flex align-items-center margin-bottom-3 justify-end">
            <div class="button-container flex align-items-center">
                <mat-icon
                    (click)="showChartView()"
                    [ngClass]="showChart ? 'icon-active' : 'icon-inactive'"
                    svgIcon="barChart"
                ></mat-icon>

                <mat-icon
                    (click)="showChartDataView()"
                    [ngClass]="showChartData ? 'icon-active' : 'icon-inactive'"
                    svgIcon="listBulleted"
                ></mat-icon>

                <ui-button (click)="onExport()" type="outline">{{ 'reporting.reports.export' | translate }} </ui-button>
            </div>
        </div>

        <app-chart *ngIf="this.showChart && chartData?.datasets" [chartData]="chartData" [report]="report"></app-chart>

        <div *ngIf="this.showChartData" id="table-card">
            <app-chart-data-table
                [reportingServiceData]="reportingServiceData"
                [reportSlug]="theReport"
                [height]="'400px'"
            ></app-chart-data-table>
        </div>
    </ui-card>

    <ui-card *ngIf="!hasDetailAdditionsAndTerminationsReport || !this.shouldLoadDetailReport" id="table-card">
        <app-chart-data-table
            [reportingServiceData]="reportingServiceData"
            [reportSlug]="theReport"
        ></app-chart-data-table>
    </ui-card>

    <div *ngIf="hasDetailAdditionsAndTerminationsReport && this.shouldLoadDetailReport">
        <div
            *ngIf="
                detailAdditionsAndTerminationsReport &&
                    detailAdditionsAndTerminationsReport.data.sheets &&
                    detailAdditionsAndTerminationsReport.data.sheets.length;
                else emptyState
            "
            class="report-body"
        >
            <app-report-table
                [scrollable]="false"
                #reportTable
                [report]="detailAdditionsAndTerminationsReport"
                [noBottomBorder]="true"
                [showExportButton]="true"
                [makeHeaderRowSticky]="false"
            ></app-report-table>
        </div>
    </div>

    <ng-template #emptyState>
        <ui-card>
            <app-empty-state label="reporting.reports.noDataWithFiltersApplied"></app-empty-state>
        </ui-card>
    </ng-template>
</div>
